module.exports = __webpack_public_path__ + "img/adam-login-logo.28b81a16.png";